"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Memo;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Memo(changeFn, materializer) {
  var lastParams = [];
  var value = void 0;

  return function (state) {
    var newParams = changeFn(state);
    var recompute = function recompute() {
      lastParams = newParams;
      value = materializer.apply(undefined, _toConsumableArray(lastParams));
      return value;
    };

    if (newParams.length !== lastParams.length) {
      return recompute();
    }

    for (var i = 0; i < newParams.length; i++) {
      if (newParams[i] !== lastParams[i]) {
        return recompute();
      }
    }

    return value;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-charts/es/utils/Memoize.js
// module id = 1406
// module chunks = 0